import * as React from 'react';
import { useState, useEffect } from 'react';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import Paper from '@mui/material/Paper';
import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFns';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import ptBR from 'date-fns/locale/pt-BR';
import Service from '../services/Service';
import {
    Container,
    Grid,
    IconButton,
    TablePagination,
    Typography,
    Box,
    Chip,
    Card,
    CardContent,
    Alert,
    CircularProgress,
    Tooltip,
    Badge,
    Button,
    Dialog,
    DialogTitle,
    DialogContent,
    DialogActions,
    List,
    ListItem,
    ListItemIcon,
    ListItemText,
    Divider
} from '@mui/material';
import {
    Add as AddIcon,
    Delete as DeleteIcon,
    Close as CloseIcon,
    ExpandMore as ExpandMoreIcon,
    Edit as EditIcon,
    Save as SaveIcon,
    Email as EmailIcon,
    Warning as WarningIcon,
    Send as SendIcon,
    Person as PersonIcon
} from '@mui/icons-material';
import VisibilityIcon from '@mui/icons-material/Visibility';
import FilterListIcon from '@mui/icons-material/FilterList';
import { useLocation, useNavigate, Link } from 'react-router-dom';
import RefreshIcon from '@mui/icons-material/Refresh';
import { format, parse, subDays } from 'date-fns';
import { DatePicker } from '@mui/x-date-pickers';
import LicitacaoDetailDialog from './LicitacaoDetailDialog';


const columns = [
    { id: 'dataBusca', label: 'Data', minWidth: 100 },
    { id: 'orgaos', label: 'Órgão', minWidth: 200 },
    { id: 'numero', label: 'Número', minWidth: 100 },
    { id: 'objeto', label: 'Descrição', minWidth: 400 },
    { id: 'dataAbertura', label: 'Abertura', minWidth: 100 },
    { id: 'cidadeUf', label: 'Cidade/UF', minWidth: 120 },
];

export default function LicitacaoUserView(props) {
    const { setWait } = props;
    const [erro, setErro] = useState();
    const [lici, setLici] = useState([]);
    const [filtrado, setFiltrado] = useState([]);
    const [dataInicio, setDataInicio] = useState(new Date());
    const [dataFim, setDataFim] = useState(new Date());
    const [page, setPage] = useState(0);
    const [rowsPerPage, setRowsPerPage] = useState(10);
    const [configUser, setConfigUser] = useState(null);
    const [filtrosDisponiveis, setFiltrosDisponiveis] = useState([]);
    const [filtroSelecionado, setFiltroSelecionado] = useState('todos');
    const [loading, setLoading] = useState(false);
    const [dialogEmailOpen, setDialogEmailOpen] = useState(false);
    const [detailDialogOpen, setDetailDialogOpen] = useState(false);
    const [selectedLicitacao, setSelectedLicitacao] = useState(null);

    const location = useLocation();
    const navigate = useNavigate();


    useEffect(() => {
        const queryParams = new URLSearchParams(location.search);
        const id = queryParams.get('id');
        if (id) {

            carregarConfigUser(id);
        }
    }, [location]);

    useEffect(() => {
        if (lici.length > 0) {
            aplicarFiltros();
        }
    }, [lici, filtroSelecionado]);

    const carregarConfigUser = async (id) => {
        // setLoading(true);
        try {
            const response = await Service.GET("/api/configUser/id?id=" + id, setWait);
            if (response && response.id) {
                setConfigUser(response);
                if (response.filtros) {
                    setFiltrosDisponiveis(response.filtros);
                }
                await buscarLicitacoes(id);
            }
        } catch (error) {
            if (error.message !== 'duplicado') {
                setErro("Erro ao carregar configuração: " + error.statusText);
            }
        } finally {
            // setLoading(false);
        }
    };

    const buscarLicitacoes = async (id) => {
        // setLoading(true);
        try {
            const hoje = new Date();
            const ontem = subDays(hoje, 1);

            const dataInicioFormatada = format(ontem, 'yyyy-MM-dd');
            const dataFimFormatada = format(hoje, 'yyyy-MM-dd');

            // Atualiza os estados
            setDataInicio(ontem);
            setDataFim(hoje);

            const url = `/api/configUser/buscar/custom?id=${id}&refresh=false&dataInicio=${dataInicioFormatada}&dataFim=${dataFimFormatada}&refresh=true`;
            // console.log("Buscando com datas:", url);
            // const response = await Service.GET("/api/configUser/buscar?id=" + id + "&refresh=false", setWait);

            const response = await Service.GET(url, setWait);

            // const response = await Service.GET("/api/configUser/buscar/custom?id=" + id + "&refresh=false&dataInicio=" + hoje + "&dataFim=" + ontem + "&refresh=true", setWait);

            if (response && response.length > 0) {
                setLici(response);
            } else {
                setLici([]);
                setFiltrado([]); 
            }
        } catch (error) {
            if (error.message !== 'duplicado') {
                setErro("Erro ao buscar licitações: " + error.statusText);
            }
            setLici([]);
            setFiltrado([]);
        } finally {
            // setLoading(false);
        }
    };

    const handleEnviarEmail = async () => {
        setDialogEmailOpen(false);
        setLoading(true);
        try {
            const queryParams = new URLSearchParams(location.search);
            const id = queryParams.get('id');
            const response = await Service.GET("/api/configUser/enviarEmail?id=" + id + "&refresh=false&dataInicio=" + format(dataInicio, 'yyyy-MM-dd') + "&dataFim=" + format(dataFim, 'yyyy-MM-dd') + "&refresh=true", setWait);
            if (response && response.length > 0) {
            } else {
            }
        } catch (error) {
            if (error.message !== 'duplicado') {
                setErro("Erro ao buscar licitações: " + error.statusText);
            }
            setLoading(false);
        } finally {
            setLoading(false);
        }
    };


    const getUfValue = (item) => {
        if (!item) return '';

        if (typeof item.uf === 'string' && item.uf.trim()) {
            return item.uf.trim().toUpperCase();
        }

        if (typeof item.cidadeUf === 'string') {
            const partes = item.cidadeUf.split('/');
            const uf = partes[partes.length - 1]?.trim();
            if (uf) return uf.toUpperCase();
        }

        return '';
    };

    const aplicarFiltros = () => {
        let dadosFiltrados = [...lici];

        if (filtroSelecionado !== 'todos') {
            dadosFiltrados = dadosFiltrados.filter(item => {
                // Verifica se o item tem scores
                if (!item.scores || item.scores.length === 0) return false;

                // Busca o score que corresponde ao filtro selecionado
                const scoreMatch = item.scores.find(score => score.nome === filtroSelecionado);

                // Retorna true se encontrou match e o matched é true
                return scoreMatch && scoreMatch.matched === true;
            });
        }

        // Ordenar por UF, depois por prioridade do score e data
        dadosFiltrados.sort((a, b) => {
            const ufA = getUfValue(a);
            const ufB = getUfValue(b);

            if (ufA !== ufB) {
                return ufA.localeCompare(ufB, 'pt-BR');
            }

            // Primeiro por prioridade do score (se tiver filtro selecionado)
            if (filtroSelecionado !== 'todos') {
                const scoreA = a.scores?.find(s => s.nome === filtroSelecionado);
                const scoreB = b.scores?.find(s => s.nome === filtroSelecionado);

                if (scoreA && scoreB) {
                    if (scoreA.prioridade !== scoreB.prioridade) {
                        return scoreA.prioridade - scoreB.prioridade;
                    }
                } else if (scoreA) return -1;
                else if (scoreB) return 1;
            }

            // Depois por data de abertura (mais recente primeiro)
            const dateA = new Date(a.dataAbertura?.split('/').reverse().join('-'));
            const dateB = new Date(b.dataAbertura?.split('/').reverse().join('-'));
            return dateB - dateA;
        });

        setFiltrado(dadosFiltrados);
        setPage(0);
    };

    const truncarTexto = (texto, maxLength = 100) => {
    if (!texto || typeof texto !== 'string') return texto;
    if (texto.length <= maxLength) return texto;
    return texto.substring(0, maxLength) + '...';
};

    const handleChangePage = (event, newPage) => {
        setPage(newPage);
    };

    const handleChangeRowsPerPage = (event) => {
        setRowsPerPage(+event.target.value);
        setPage(0);
    };


    const handleClickVisualizar = (item) => {
        setSelectedLicitacao(item);
        setDetailDialogOpen(true);
    };

    // Contar quantos itens cada filtro encontrou
    const getFilterCount = (filtroNome) => {
        if (filtroNome === 'todos') return lici.length;

        return lici.filter(item => {
            if (!item.scores) return false;
            const scoreMatch = item.scores.find(score => score.nome === filtroNome);
            return scoreMatch && scoreMatch.matched === true;
        }).length;
    };

    if (loading && !lici.length) {
        return (
            <Box display="flex" justifyContent="center" alignItems="center" minHeight="400px">
                <CircularProgress />
            </Box>
        );
    }

    const onCloseDialogEmail = () => {
        setDialogEmailOpen(false);
        // setSelectedUser(null);
    };

    const filtrarPorData = async () => {
        const queryParams = new URLSearchParams(location.search);
        const id = queryParams.get('id');
        if (id) {
            // setLoading(true);
            try {
                const response = await Service.GET("/api/configUser/buscar/custom?id=" + id + "&refresh=false&dataInicio=" + format(dataInicio, 'yyyy-MM-dd') + "&dataFim=" + format(dataFim, 'yyyy-MM-dd') + "&refresh=true", setWait);
                if (response && response.length > 0) {
                    setLici(response);
                } else {
                    setLici([]);
                    setFiltrado([]);
                }
            } catch (error) {
                if (error.message !== 'duplicado') {
                    setErro("Erro ao buscar licitações: " + error.statusText);
                }
                setLici([]);
                setFiltrado([]);
            } finally {
                // setLoading(false);
            };
        }
    };

    return (
        <LocalizationProvider dateAdapter={AdapterDateFns} adapterLocale={ptBR}>
            <Container maxWidth="xl" sx={{ p: 4 }}>
                <Grid container spacing={3}>
                    <Grid item xs={12}>
                        <Card>
                            <CardContent>
                                <Box display="flex" justifyContent="space-between" alignItems="flex-start">
                                    <Box flex={1}>
                                        <Typography variant="h5" gutterBottom>
                                            {configUser?.nome || "Monitor de Licitações"}
                                        </Typography>
                                        <Box display="flex" alignItems="center" gap={2} flexWrap="wrap" mb={2}>
                                            <Typography variant="subtitle2" color="textSecondary">
                                                Período:
                                            </Typography>
                                            <LocalizationProvider dateAdapter={AdapterDateFns} adapterLocale={ptBR}>
                                                <DatePicker
                                                    label="Data Inicial"
                                                    value={dataInicio}
                                                    onChange={(newValue) => setDataInicio(newValue)}
                                                    slotProps={{ textField: { size: 'small', sx: { width: '150px' } } }}
                                                    format="dd/MM/yyyy"
                                                />
                                                <DatePicker
                                                    label="Data Final"
                                                    value={dataFim}
                                                    onChange={(newValue) => setDataFim(newValue)}
                                                    slotProps={{ textField: { size: 'small', sx: { width: '150px' } } }}
                                                    format="dd/MM/yyyy"
                                                    minDate={dataInicio}
                                                />

                                                <Button
                                                    variant="outlined"
                                                    color="primary"
                                                    startIcon={<RefreshIcon />}
                                                    disabled={loading}
                                                    onClick={filtrarPorData}
                                                >
                                                    Atualizar
                                                </Button>
                                            </LocalizationProvider>
                                        </Box>
                                        <Box display="flex" alignItems="center" gap={2} flexWrap="wrap">
                                            <Typography variant="h6">
                                                Filtros de Interesse:
                                            </Typography>
                                        </Box>
                                        <Box mt={2} display="flex" gap={1} flexWrap="wrap">
                                            <Chip
                                                key="todos-itens"
                                                label={`Todos (${getFilterCount('todos')})`}
                                                onClick={() => setFiltroSelecionado('todos')}
                                                color={filtroSelecionado === 'todos' ? "primary" : "default"}
                                                variant={filtroSelecionado === 'todos' ? "filled" : "outlined"}
                                                icon={<FilterListIcon />}
                                            />
                                            {filtrosDisponiveis.map((filtro) => (
                                                <Chip
                                                    key={filtro.nome}
                                                    label={`${filtro.nome} (${getFilterCount(filtro.nome)})`}
                                                    onClick={() => setFiltroSelecionado(filtro.nome)}
                                                    color={filtroSelecionado === filtro.nome ? "primary" : "default"}
                                                    variant={filtroSelecionado === filtro.nome ? "filled" : "outlined"}
                                                    icon={<FilterListIcon />}
                                                />
                                            ))}
                                        </Box>
                                    </Box>

                                    {/* Botões de ação */}
                                    <Box display="flex" gap={2} ml={2}>
                                        <Button
                                            variant="contained"
                                            color="secondary"
                                            startIcon={<EmailIcon />}
                                            onClick={() => setDialogEmailOpen(true)}
                                            disabled={loading || filtrado.length === 0}
                                        >
                                            Enviar E-mail
                                        </Button>
                                        <Button
                                            variant="contained"
                                            color="primary"
                                            // startIcon={<EmailIcon />}
                                            // onClick={() => navigate(`/configUser`)}
                                            // disabled={loading || filtrado.length === 0}
                                            component={Link}
                                            to={`/configUser`}
                                        >
                                            Voltar
                                        </Button>
                                    </Box>
                                </Box>
                            </CardContent>
                        </Card>
                    </Grid>
                    {/* Tabela de resultados */}
                    <Grid item xs={12}>
                        <Paper sx={{ width: '100%', overflow: 'hidden' }}>
                            <TableContainer sx={{ maxHeight: 600 }}>
                                <Table stickyHeader>
                                    <TableHead>
                                        <TableRow sx={{
                                            "& th": {
                                                color: "#fff",
                                                backgroundColor: '#1976d2',
                                                fontWeight: 'bold'
                                            }
                                        }}>
                                            {columns.map((column) => (
                                                <TableCell
                                                    key={column.id}
                                                    style={{ minWidth: column.minWidth }}
                                                >
                                                    {column.label}
                                                </TableCell>
                                            ))}
                                            <TableCell style={{ minWidth: 80 }}>Scores</TableCell>
                                            <TableCell style={{ minWidth: 80 }}>Ações</TableCell>
                                        </TableRow>
                                    </TableHead>
                                    <TableBody>
                                        {filtrado.length === 0 ? (
                                            <TableRow>
                                                <TableCell colSpan={columns.length + 2} align="center">
                                                    <Typography variant="h6" color="textSecondary" sx={{ py: 4 }}>
                                                        Nenhum item encontrado com os filtros selecionados
                                                    </Typography>
                                                </TableCell>
                                            </TableRow>
                                        ) : (
                                            filtrado
                                                .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
                                                .map((row) => (
                                                    <TableRow hover key={row.id}>
                                                        {columns.map((column) => (
                                                            <TableCell key={column.id}>
                                                                {/* {row[column.id]} */}
                                                                {column.id === 'objeto' ? truncarTexto(row[column.id], 150) : (column.id === 'orgaos' ? truncarTexto(row[column.id], 80) : row[column.id])}

                                                            </TableCell>
                                                        ))}
                                                        <TableCell>
                                                            <Box display="flex" gap={0.5} flexWrap="wrap">
                                                                {row.scores?.filter(s => s.matched).map((score) => (
                                                                    <Tooltip
                                                                        key={score.nome}
                                                                        title={`Matches: ${score.totalMatches}`}
                                                                    >
                                                                        <Chip
                                                                            label={score.nome}
                                                                            size="small"
                                                                            color={filtroSelecionado === score.nome ? "primary" : "default"}
                                                                            variant={filtroSelecionado === score.nome ? "filled" : "outlined"}
                                                                        />
                                                                    </Tooltip>
                                                                ))}
                                                                {(!row.scores || row.scores.filter(s => s.matched).length === 0) && (
                                                                    <Typography variant="caption" color="textSecondary">
                                                                        Nenhum score
                                                                    </Typography>
                                                                )}
                                                            </Box>
                                                        </TableCell>
                                                        <TableCell>
                                                            <Tooltip title="Visualizar detalhes">
                                                                <IconButton
                                                                    onClick={() => handleClickVisualizar(row)}
                                                                    size="small"
                                                                >
                                                                    <VisibilityIcon />
                                                                </IconButton>
                                                            </Tooltip>
                                                        </TableCell>
                                                    </TableRow>
                                                ))
                                        )}
                                    </TableBody>
                                </Table>
                            </TableContainer>
                            <TablePagination
                                rowsPerPageOptions={[10, 25, 50, 100]}
                                component="div"
                                count={filtrado.length}
                                rowsPerPage={rowsPerPage}
                                page={page}
                                onPageChange={handleChangePage}
                                onRowsPerPageChange={handleChangeRowsPerPage}
                                labelRowsPerPage="Linhas por página"
                                labelDisplayedRows={({ from, to, count }) => `${from}-${to} de ${count}`}
                            />
                        </Paper>
                    </Grid>

                    {erro && (
                        <Grid item xs={12}>
                            <Alert severity="error" onClose={() => setErro(null)}>
                                {erro}
                            </Alert>
                        </Grid>
                    )}
                </Grid>
                <LicitacaoDetailDialog
                    open={detailDialogOpen}
                    onClose={() => setDetailDialogOpen(false)}
                    licitacao={selectedLicitacao}
                />
                <Dialog
                    open={dialogEmailOpen}
                    onClose={onCloseDialogEmail}
                    maxWidth="sm"
                    fullWidth
                >
                    <DialogTitle>
                        <Box display="flex" justifyContent="space-between" alignItems="center">
                            <Box display="flex" alignItems="center" gap={1}>
                                <EmailIcon color="primary" />
                                <Typography variant="h6">
                                    Confirmar Envio de Email
                                </Typography>
                            </Box>
                            <IconButton onClick={onCloseDialogEmail} size="small">
                                <CloseIcon />
                            </IconButton>
                        </Box>
                    </DialogTitle>

                    <DialogContent dividers>
                        <Grid container spacing={3}>
                            {/* Informação da configuração */}
                            <Grid item xs={12}>
                                <Alert severity="info" icon={<WarningIcon />}>
                                    <Typography variant="body2">
                                        Você está prestes a enviar um relatório para:
                                    </Typography>
                                </Alert>
                            </Grid>

                            {/* Lista de emails */}
                            <Grid item xs={12}>
                                <Paper variant="outlined" sx={{ p: 2, bgcolor: '#f5f5f5' }}>
                                    <Typography variant="subtitle2" gutterBottom color="primary">
                                        Destinatários ({configUser?.emails?.length || 0})
                                    </Typography>
                                    <List dense disablePadding>
                                        {configUser?.emails?.map((email, index) => (
                                            <ListItem key={index} disablePadding sx={{ py: 0.5 }}>
                                                <ListItemIcon sx={{ minWidth: 35 }}>
                                                    <PersonIcon fontSize="small" color="action" />
                                                </ListItemIcon>
                                                <ListItemText
                                                    primary={email}
                                                    primaryTypographyProps={{
                                                        variant: 'body2',
                                                        style: { wordBreak: 'break-all' }
                                                    }}
                                                />
                                            </ListItem>
                                        ))}
                                    </List>
                                </Paper>
                            </Grid>
                        </Grid>
                    </DialogContent>

                    <DialogActions sx={{ p: 2, gap: 1 }}>
                        <Button
                            onClick={onCloseDialogEmail}
                            variant="outlined"
                        >
                            Cancelar
                        </Button>
                        <Button
                            onClick={handleEnviarEmail}
                            variant="contained"
                            color="primary"
                        >
                            Confirmar Envio
                        </Button>
                    </DialogActions>
                </Dialog>
            </Container>
        </LocalizationProvider>
    );
}